import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { SingleSelectFilterPicker } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { DateFilterPickerPresets } from './DateFilterPicker.types';
export function DateFilterPicker(props) {
    const { value, onChange } = props;
    const { t: texts } = useLocaleKeys('invoice');
    const datesPresets = useMemo(()=>[
            {
                label: texts.datePresetLabels.allTime(),
                value: DateFilterPickerPresets.AllTime
            },
            {
                label: texts.datePresetLabels.today(),
                value: DateFilterPickerPresets.Today
            },
            {
                label: texts.datePresetLabels.thisWeek(),
                value: DateFilterPickerPresets.ThisWeek
            },
            {
                label: texts.datePresetLabels.thisMonth(),
                value: DateFilterPickerPresets.ThisMonth
            },
            {
                label: texts.datePresetLabels.previousMonth(),
                value: DateFilterPickerPresets.PreviousMonth
            },
            {
                label: texts.datePresetLabels.lastThreeMonths(),
                value: DateFilterPickerPresets.LastThreeMonths
            }
        ], [
        texts
    ]);
    return /*#__PURE__*/ _jsx(SingleSelectFilterPicker, {
        value: value,
        testId: 'date-filter-picker',
        options: datesPresets,
        label: texts.filterLabels.date(),
        onChange: (option)=>option ? onChange(option.value) : null
    });
}
